import { default as ax } from "axios";
import store from "@/store";

import refreshTokeninterceptor from "./utils.js";
import { getBaseUrlDelviumBackend } from "@shared/utils/functions";
import { additionalTokenNames } from "@shared/additional-forms/utils.js";

const axios = ax.create({
    baseURL: getBaseUrlDelviumBackend(),
});

axios.interceptors.request.use(
    (config) => {
        const tokens = store.getters["AdditionalFormsStore/getAuthTokens"];
        const token = tokens?.[additionalTokenNames.token];

        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(undefined, refreshTokeninterceptor(axios));
export default axios;
